import React, { useState, useEffect } from 'react';
import { ProLayout } from '@ant-design/pro-components';
import {Link, useLocation, Outlet, useNavigate} from 'react-router-dom';
import { Badge, Button } from 'antd';
import {
    BulbOutlined,
    HighlightOutlined,
    LogoutOutlined,
    ProfileOutlined,
    ReadOutlined,
    HomeOutlined,
    UserOutlined,
    ContactsOutlined,
    SlidersOutlined,
    AreaChartOutlined,
    FileSearchOutlined,
    WarningOutlined,
} from '@ant-design/icons';
import { FaTelegramPlane } from "react-icons/fa";
import {CheckAdmin, CheckMentor} from "../components/Layout";
import { getAmountLatestNews } from '../components/News';
import { contextNews } from '../shared/context';

const Layout = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [theme, setTheme] = useState(localStorage.getItem('theme'));
    const [isAdmin, setIsAdmin] = useState(null);
    const [isMentor, setIsMentor] = useState(null);
    const [menuCollapsed, setMenuCollapsed] = useState(false);
    const [newsBadge, setNewsBadge] = useState(false);

    useEffect(() => {
        localStorage.setItem('theme', theme);
    });

    useEffect(()=>{
        getAmountLatestNews().then((res)=>{
            setNewsBadge(res.amount > 0 ? !!res.amount : false);
        })
    },[])

    const handleMenuOpen = () => {
        if (window.innerWidth <= 768) {
            window.scrollTo({top: 0, behavior: "smooth"});
            document.body.style.overflow = "hidden";
        }
    };

    const handleMenuClose = () => {
        if (window.innerWidth <= 768) {
            document.body.style.overflow = "";
        }
    };


    const checkAdmin = async () => {
        try {
            const data = await CheckAdmin();
            if (data?.admin === true) {
                setIsAdmin(true);
            } else {
                setIsAdmin(false);
            }
        } catch (error) {
            setIsAdmin(false);
        }
    };
    const checkMentor = async () => {
        try {
            const data = await CheckMentor();
            if (data?.mentor === true) {
                setIsMentor(true);
            } else {
                setIsMentor(false);
            }
        } catch (error) {
            setIsMentor(false);
        }
    };
    checkAdmin();
    checkMentor();
    const menuData = [
        { path: '/profile', name: 'Профиль', icon: <UserOutlined /> },
        { path: '/ratingtable', name: 'Таблица рейтинга', icon: <ProfileOutlined /> },
        { path: '/news', name: 'Новости', icon: <HomeOutlined /> },
        // { path: '/calendar', name: 'Календарь', icon: <CalendarOutlined /> },
        { path: '/courses', name: 'Курсы', icon: <ReadOutlined /> },
        { path: '/contacts', name: 'Контакты', icon: <ContactsOutlined /> },
        { path: '/support', name: 'Поддержка', icon: <WarningOutlined /> },
    ];

    if (isMentor) {
        menuData.push(
            { path: '/mentor-tools', name: 'Инструменты ментора', icon: <SlidersOutlined /> },
            { path: '/dashboard-view', name: 'Дашборд', icon: <AreaChartOutlined /> },
        );
    }

    if (isAdmin) {
        menuData.push(
            { path: '/admin-tools', name: 'Инструменты администратора', icon: <SlidersOutlined /> },
            { path: '/dashboard', name: 'Дашборд', icon: <AreaChartOutlined /> },
            { path: '/logs', name: 'Логирование', icon: <FileSearchOutlined /> },
        );
    }

    const toggleTheme = () => {
        setTheme((prev) => (prev === 'light' ? 'realDark' : 'light'));
    };

    const logout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };

    return (
        <contextNews.Provider value={{
            setisReadLatestNews: setNewsBadge,
            isReadLatestNews: newsBadge
        }}>
        <ProLayout
            title={
                <span
                    style={{ textDecoration: "none", color: "inherit" }}
                    onClick={() => navigate("/")}
                >
                    Code.ak
                </span>
            }
            logo={theme === 'light' ? '/icon.png' : '/icon1.png'}
            layout="mix"
            location={{ pathname: location.pathname }}
            route={{
                path: '/',
                routes: menuData,
            }}
            menuItemRender={(item, dom) => {
                const isNews = item.key === '/news';
                if (isNews) {
                    return (
                        <Link to={item.path || '/'}>
                            <Badge dot={newsBadge} size='small' title={newsBadge} offset={menuCollapsed ? [-10,10] : [10]}>
                                {dom}
                            </Badge>
                        </Link>
                    )    
                }

                return (
                    <Link to={item.path || '/'}>{dom}</Link>
                )
            }}
            fixSiderbar
            fixedHeader
            navTheme={theme}
            collapsed={menuCollapsed}
            onCollapse={(collapsed) => {
                setMenuCollapsed(collapsed);
                if (!collapsed) {
                    handleMenuOpen();
                } else {
                    handleMenuClose();
                }
            }}
            rightContentRender={() => (
                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    <Button
                        onClick={toggleTheme}
                        icon={theme === 'light' ? <BulbOutlined /> : <HighlightOutlined />}
                    />
                    <Button danger onClick={logout} icon={<LogoutOutlined />} />
                </div>
            )}
            menuFooterRender={() => (
                <div style={{ padding: 16, textAlign: 'center' }}>
                    <a
                        href="https://t.me/+pCZ3VGGtsRY1OTMy"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 8,
                            color: theme === 'light' ? '#1890ff' : '#A6A6A6',
                            fontWeight: 500,
                            textDecoration: 'none',
                            transition: 'all 0.3s ease',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                    >
                        <FaTelegramPlane style={{ fontSize: 18 }} />
                    </a>
                </div>
            )}
            footerRender={() => (
                <div style={{ marginTop:'100px', marginBottom:'10px', textAlign: 'center', padding: '12px 0', color: theme === 'light' ? '#999' : '#aaa' }}>
                    © {new Date().getFullYear()} Code.ak — Все права защищены
                </div>
            )}
        >
            <Outlet />
        </ProLayout>
        </contextNews.Provider>

    );
};

export default Layout;
